import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import UserEcg12 from '../../components/Shared/Ecg12/UserEcg12'
import MainBlockContainer from '../MainBlockContainer';
import MainBlockHeader from '../MainBlockHeader'
import { useTranslation } from 'react-i18next';

export default function ConsultationUserEcg12() {  
  let { consultationUid } = useParams();
  const { t } = useTranslation();

  return (
    <>              
      <MainBlockHeader header={t('ecg12.header')} />

      <MainBlockContainer>
        <UserEcg12 apiEcg12BaseUrl={`/consultation/expert/accepted/${consultationUid}/user/ecg12`}/>      
      </MainBlockContainer>
    </>
  );  
}